import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import type { AgentOptions } from '@newrelic/browser-agent/loaders/agent'

const parseBoolean = (value: string | undefined, defaultValue = false): boolean => {
  if (value == null) return defaultValue
  return value === 'true' || value === '1'
}

const parseList = (value: string | undefined): string[] => {
  if (!value) return []
  return value.split(',').map((item) => item.trim()).filter(Boolean)
}

const requiredConfig = {
  accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
  agentID: process.env.REACT_APP_NEW_RELIC_AGENT_ID,
  applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
  licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
}

const isConfigured = Object.values(requiredConfig).every(Boolean)
const isEnabled = parseBoolean(process.env.REACT_APP_NEW_RELIC_ENABLED)

if (isEnabled && isConfigured) {
  const beacon = process.env.REACT_APP_NEW_RELIC_BEACON || 'bam.nr-data.net'
  const errorBeacon = process.env.REACT_APP_NEW_RELIC_ERROR_BEACON || beacon
  const trustKey = process.env.REACT_APP_NEW_RELIC_TRUST_KEY || requiredConfig.accountID
  const distributedTracingEnabled = parseBoolean(process.env.REACT_APP_NEW_RELIC_DISTRIBUTED_TRACING_ENABLED)

  const options: AgentOptions = {
    init: {
      ajax: {
        deny_list: [
          beacon,
          errorBeacon,
          'bam-cell.nr-data.net',
        ],
      },
      browser_consent_mode: {
        enabled: false,
      },
      distributed_tracing: {
        enabled: distributedTracingEnabled,
        cors_use_newrelic_header: distributedTracingEnabled,
        cors_use_tracecontext_headers: distributedTracingEnabled,
        allowed_origins: parseList(process.env.REACT_APP_NEW_RELIC_DISTRIBUTED_TRACING_ALLOWED_ORIGINS),
      },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true,
      },
      privacy: {
        cookies_enabled: parseBoolean(process.env.REACT_APP_NEW_RELIC_COOKIES_ENABLED, true),
      },
      session_replay: {
        enabled: parseBoolean(process.env.REACT_APP_NEW_RELIC_SESSION_REPLAY_ENABLED),
      },
      soft_navigations: {
        enabled: true,
      },
    },
    info: {
      beacon,
      errorBeacon,
      licenseKey: requiredConfig.licenseKey!,
      applicationID: requiredConfig.applicationID!,
      sa: 1,
    },
    loader_config: {
      accountID: requiredConfig.accountID,
      agentID: requiredConfig.agentID,
      applicationID: requiredConfig.applicationID,
      licenseKey: requiredConfig.licenseKey,
      trustKey,
    },
  }

  new BrowserAgent(options)
}
